import { Box, Button, Container, Typography } from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import useList from "./useList";
import BulkEmail from "@/templates/BulkEmail";

/**
 * 이메일 대량 발송 관리 페이지
 * @description CSV 파일 업로드를 통한 대량 멤버 초대 및 임시패스워드 발송
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-15
 */
export const List = () => {
  const {
    csvFile,
    csvData,
    isUploading,
    isSending,
    sendProgress,
    sendResults,
    selectedDoJangId,
    selectedDoJangName,
    handleFileUpload,
    handleSendEmails,
    handleFileRemove,
    handleDoJangChange,
  } = useList();

  return (
    <Container maxWidth={"xl"}>
      {/* 헤더 영역 - 다른 페이지와 동일한 패턴 */}
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          이메일 대량 발송
        </Typography>
        <Button
          variant={"contained"}
          disableElevation
          startIcon={<RefreshIcon />}
          onClick={() => window.location.reload()}
          disabled={isSending}
        >
          새로고침
        </Button>
      </Box>

      {/* Template 컴포넌트 사용 */}
      <BulkEmail.List
        csvFile={csvFile}
        csvData={csvData}
        isUploading={isUploading}
        isSending={isSending}
        sendProgress={sendProgress}
        sendResults={sendResults}
        selectedDoJangId={selectedDoJangId}
        selectedDoJangName={selectedDoJangName}
        onFileUpload={handleFileUpload}
        onSendEmails={handleSendEmails}
        onFileRemove={handleFileRemove}
        onDoJangChange={handleDoJangChange}
      />
    </Container>
  );
};
